import PostEventScreen from './postEventScreen';
export default PostEventScreen;
